import React from 'react';
import { AnnouncementDetailResponse } from '@/main/models/response/announcementResponse';
import { AnnouncementStatusEnum } from '@/main/services/enum/AnnouncementStatusEnum';
import { getTranslateByKey } from '@/main/services/utils';
import { Alert } from '@mui/material';
import { isNil } from 'lodash';

interface Props {
  announcement: AnnouncementDetailResponse | undefined;
}

export function AnnouncementRegisterWarnning({ announcement }: Props) {
  if (isNil(announcement)) return <></>;

  if (announcement.idAnnouncementStatus != AnnouncementStatusEnum.Draft)
    return <></>;

  return (
    <Alert severity="warning" style={{ margin: '10px 0' }}>
      {getTranslateByKey('information.announcementWarnningDraft')}
    </Alert>
  );
}
